import { isApiError } from '@qrkey/api-client';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The till answers its own reads offline (src/offline): never pause them just
      // because the browser says it is offline.
      networkMode: 'always',
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Problems (4xx) are answers, not blips: do not retry them.
      retry: (count, error) => !(isApiError(error) && error.status < 500) && count < 2,
    },
    mutations: { retry: false, networkMode: 'always' },
  },
});
